import { CustomDropdown } from 'components/shared/CustomDropdown';
import { HelperConstant } from '../../helpers/HelperConstant';
import { getPersonId, isRider } from '../../helpers/TokenHelper';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import { IOrderRejectModel } from 'models/OrderReject.Model';
import React, { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { Col, Form, FormFeedback, Row } from 'reactstrap';
import CommonService from 'services/CommonService';
import { CustomAmount } from 'components/shared/CustomAmount';
import { isIn } from '../../helpers/Helper';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomButton } from 'components/shared/CustomButton';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { values } from 'lodash';
import CustomLoader from 'components/Common/CustomLoader';
import { useNavigate } from 'react-router-dom';

type props = {
    orderSummaryData?: IGetOrderSummaryModel,
    setShowModal?: any,
    isCancel?: boolean,
    encryptedOrderId: any
};

function CancelOrder({ setShowModal, orderSummaryData, isCancel, encryptedOrderId }: props) {
    const riderlogin: boolean = isRider() ?? false;
    let navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, watch } = useForm<IOrderRejectModel>();

    const [section, setSection] = useState<Array<any>>([]);
    const [cancellationType, setCancellationType] = useState<Array<any>>([]);

    const [cancelOrder, setCancelOrder] = useState();

    const [isButton, setisButton] = useState<boolean>(false);
    const [isButton1, setisButton1] = useState<boolean>(false);
    const [showLoading, setShowLoading] = useState(false);

    const validation: any = useFormik<IOrderRejectModel>({

        enableReinitialize: true,
        initialValues: {
            id: 0,
            created: '',
            createdBy: 0,
            active: true,
            modified: '',
            modifiedBy: 0,
            validationErrors: '',
            orderId: 0,
            customerExpectation: 0,
            remarks: '',
            reason: 0
        },
        validationSchema: Yup.object().shape({
            remarks: Yup.string().required("Please Enter Your Remarks"),
            reason: Yup.string().notOneOf(['0'], 'Please Select Your Reason').required("Please Select Your Reason"),
        }),
        onSubmit(values: any) {
            setShowLoading(true)
            setisButton1(true);
            setisButton(true);
            const Data = {
                id: 0,
                created: "",
                createdBy: 0,
                active: true,
                modified: "",
                modifiedBy: 0,
                validationErrors: "",
                orderId: 0,
                customerExpectation: values.customerExpectation,
                remarks: values.remarks,
                reason: parseInt(values.reason),
                personId: 0
            };
            isCancel ?
                CommonService.postWithEntityandSingleQueryParam("Sell", "CancelOrder", Data, "encryptedOrderId", encryptedOrderId).then(res => {
                    if (res.status === 200) {
                        if (!riderlogin) {
                            setShowLoading(false)
                            window.location.href = "/homepage";
                            setShowModal(false);
                        }
                        else {
                            window.location.href = '/technicianhistory';
                            setShowModal(false);
                        }
                        setisButton1(false);
                    }
                }).catch(e => {
                    console.log(e);
                })
                :
                CommonService.postWithEntityandSingleQueryParam("Sell", "RejectOrder", Data, "encryptedOrderId", encryptedOrderId).then(res => {
                    if (res.status === 200) {
                        setShowLoading(false)
                        setisButton(false);
                        window.location.href = "/homepage";
                        setShowModal(false);
                    }
                }).catch(e => {
                    console.log(e);
                })

        },

    });

    useEffect(() => {
        CommonService.getWithQueryParam("master", "GetAllFailureType", 'serviceTypeId', HelperConstant.serviceTypeId.SELL).then(response => {
            if (response.status === 200) {
                setSection(response.data);
            }
        }).catch(e => {
            if (e == 'Request failed with status code 401') {
                navigate('/logout')
            } else {
                console.error("API error:", e);
            }
            setShowLoading(false);
        })

        CommonService.getWithQueryParam("master", "GetAllCancellationType", 'serviceTypeId', HelperConstant.serviceTypeId.SELL).then(response => {
            if (response.status === 200) {
                setCancellationType(response.data);
            }
        }).catch(exception => console.log(exception));

    }, [])


    return (
        <React.Fragment>
            <Row className='m-2'>
                <Col xl={12} className=''>
                    <div className='d-flex justify-content-between'>
                        <p className='font-size-16 fw-semibold text-dofy'>Order Fail</p>
                        <i className='mdi mdi-close align-top font-size-16 cursor-pointer' onClick={() => setShowModal(false)}></i>
                    </div>
                    <div>
                        <span className='text-dofy font-size-14'>Order Id: </span>
                        <span className='text-dofy font-size-16 fw-semibold'>{orderSummaryData?.OrderCode}</span>
                    </div>
                    <CustomLoader isOpen={showLoading} />
                    <div>
                        <Form className="form-horizontal"
                            onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                        >
                            {isCancel ?
                                <CustomDropdown isMandatory={true} label={'Reason'} id={'reason'} name={'reason'} value={validation?.value?.reason} data={cancellationType} error={validation.errors.reason} displayField='Name' valueField='Id'
                                    onChange={validation?.handleChange}
                                    onBlur={validation?.handleBlur}
                                    invalid={validation?.touched?.reason && validation?.errors?.reason ? true : false}
                                />
                                :
                                <CustomDropdown isMandatory={true} label={'Reason'} name={'reason'} id={'reason'} value={validation?.value?.reason} data={section} error={validation.errors.reason} displayField='Name' valueField='Id'
                                    onChange={validation?.handleChange}
                                    onBlur={validation?.handleBlur}
                                    invalid={validation?.touched?.reason && validation?.errors?.reason ? true : false}
                                />}

                            {validation?.touched?.reason && validation?.errors?.reason ? (
                                <FormFeedback type="invalid">{validation?.errors?.reason}</FormFeedback>
                            ) : null}
                            <div className='mb-1'>
                                {!isCancel ?
                                    <CustomAmount label={'Customer Expectation Amount'} id={'customerExpectation'} value={validation?.value?.customerExpectation} error={undefined} onChange={validation?.handleChange} onBlur={validation?.handleBlur}
                                        invalid={validation?.touched?.customerExpectation && validation?.errors?.customerExpectation ? true : false} />
                                    : ""}
                                {validation?.touched?.customerExpectation && validation?.errors?.customerExpectation ? (
                                    <FormFeedback type="invalid">{validation?.errors?.customerExpectation}</FormFeedback>
                                ) : null}
                                {/* {errors.customerExpectation && <p className='text-danger m-0 mt-1'>Please enter your expection amount</p>} */}
                            </div>
                            <div className='my-1 mt-1'>
                                <CustomTextBox label={'Comments'} id={'remarks'} value={validation?.value?.remarks} error={undefined} onChange={validation?.handleChange} onBlur={validation?.handleBlur} isMandatory={true}
                                    invalid={validation?.touched?.remarks && validation?.errors?.remarks ? true : false} />
                                {validation?.touched?.remarks && validation?.errors?.remarks ? (
                                    <FormFeedback type="invalid">{validation?.errors?.remarks}</FormFeedback>
                                ) : null}
                            </div>
                            <div className='d-flex justify-content-end my-2'>
                                <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={'mdi mdi-close'} name={''} onClick={() => setShowModal(false)} />
                                <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={undefined} name={`${isCancel ? 'Cancel Order' : 'Fail Order'}`} disabled={isCancel ? isButton1 : isButton} />
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default CancelOrder
